import 'core-js'
import 'regenerator-runtime/runtime'
import 'raf/polyfill'
import React from 'react'
import ReactDOM from 'react-dom'
import * as serviceWorker from './serviceWorker'
import App from './containers/App'
import { Provider } from 'react-redux'
import configureStore from './configureStore'
import '../node_modules/unsemantic/assets/stylesheets/unsemantic-grid-responsive-tablet.css'
import './app.css'
import '../node_modules/@fortawesome/fontawesome-free/css/all.css'
import { ConnectedRouter } from 'connected-react-router'
import { createHistory } from './history'
import { QueryClient, QueryClientProvider } from 'react-query'
import OptimizelyProviderWrapper from './components/OptimizelyProviderWrapper/OptimizelyProviderWrapper'
import config from 'config'
import '@stripe/stripe-js' // Available sitewide to aid fraud prevention
import { Route } from 'react-router-dom'
import {
  createReactRouterV5Options,
  getWebInstrumentations,
  initializeFaro,
  ReactIntegration,
} from '@grafana/faro-react'
import { TracingInstrumentation } from '@grafana/faro-web-tracing'

export const history = createHistory()

const queryClient = new QueryClient()

// Initialize Faro if collector URL is configured
if (config.FARO_COLLECTOR_URL) {
  initializeFaro({
    url: config.FARO_COLLECTOR_URL,
    app: {
      name: 'rebrand-tesla',
      version: '0.1.0',
      environment: config.ENVIRONMENT_NAME?.toLowerCase() || 'unknown',
    },

    instrumentations: [
      // Mandatory, omits default instrumentations otherwise.
      ...getWebInstrumentations(),

      // Tracing package to get end-to-end visibility for HTTP requests.
      new TracingInstrumentation(),

      // React integration for React applications.
      new ReactIntegration({
        router: createReactRouterV5Options({
          history, // the history object used by react-router
          Route, // Route component imported from react-router package
        }),
      }),
    ],
  })
}

const store = configureStore()
const MOUNT_NODE = document.getElementById('app')
ReactDOM.render(
  <OptimizelyProviderWrapper>
    <Provider store={store}>
      <ConnectedRouter history={history}>
        <QueryClientProvider client={queryClient}>
          <App />
        </QueryClientProvider>
      </ConnectedRouter>
    </Provider>
  </OptimizelyProviderWrapper>,
  MOUNT_NODE,
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister()
